export const GoToShopButtonResources = {
    cashbackButtonText: "Przejdź do sklepu",
};
